import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { FormValidationModule } from '@tablesready/common-ui';
import { ModalsModule } from '../../../modals';
import { LocationInfoComponent } from './location-info.component';
import { LocationInfoRoutingModule } from './location-info-routing.module';
import {
  SmsUsageModule,
  LocationNameColumnModule,
} from '../../../components';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendGooglePlacesModule } from '@tablesready/frontend-google-places';

@NgModule({
  declarations: [
    LocationInfoComponent,
  ],
  imports: [
    NgbModule,
    FrontendIconsModule,
    FormsModule,
    CommonModule,
    ModalsModule,
    FrontendGooglePlacesModule,
    ReactiveFormsModule,
    FormValidationModule,
    SmsUsageModule,
    LocationNameColumnModule,
    LocationInfoRoutingModule,
    FrontendPullRefreshModule,
  ],
})
export class LocationInfoModule {}
